import { AxiosError, AxiosResponse } from 'axios';
import HttpStatusCode from '@client/core/http/status-codes';

/**
 * Our wrapper around problems that occur when communicating over HTTP.
 */
export class HttpException extends Error {
  readonly statusCode: HttpStatusCode;
  readonly statusText: string;
  readonly message: string;
  readonly originalResponse: AxiosResponse;

  constructor(error: AxiosError<HttpErrorResponse>) {
    super(error.message);

    if (!error.response) {
      throw new Error('HttpException given error that does not contain a Response');
    }

    this.originalResponse = error.response;
    this.statusCode = error.response.status;
    this.statusText = error.response.statusText;
    this.message = error.message;
  }
}

export interface HttpErrorResponse {
  status: HttpStatusCode;
  statusText: string;
  data?: any;
}
